import { useState } from "react";
import { IStatusModalBody } from "../../interfaces";
import { convertDataUSParaBrasilEHora } from "../../../../services/Conversores";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { Typography, Divider, Timeline, Input, Space, Dropdown } from "antd";
import type { MenuProps } from "antd";

const StatusModalBody: React.FC<IStatusModalBody> = ({
    data,
    observacao,
    arrayStatus,
    selectedStatus,
    setObservacao,
    setSelectedStatus,
}) => {
    const { TextArea } = Input;
    const { Text } = Typography;
    const [openDropdown, setOpenDropdown] = useState(false);

    if (!data) {
        return <Text type="secondary">Nenhum dado selecionado</Text>;
    }

    const statusOrder = arrayStatus.status;

    const items: MenuProps["items"] = statusOrder.map((status) => ({
        key: status,
        label: status,
        disabled: status === selectedStatus || status === data.status,
    }));

    const handleMenuClick: MenuProps["onClick"] = ({ key }) => {
        setSelectedStatus(key);
    };

    return (
        <>
            <Space direction="vertical" style={{ width: "100%", flexDirection:'row', alignItems:'center' }}>
                <Text strong>Status atual:</Text>
                <Space align="center">
                    <Dropdown.Button
                        menu={{
                            items,
                            onClick: handleMenuClick,
                        }}
                        open={openDropdown}
                        onOpenChange={(open) => setOpenDropdown(open)}
                        type="default"
                        icon={openDropdown ? <CaretUpOutlined /> : <CaretDownOutlined />}
                    >
                        {selectedStatus || data.status}
                    </Dropdown.Button>
                </Space>
            </Space>
            <Divider />
            <Text strong>Observação (opcional)</Text>
            <TextArea
                rows={3}
                placeholder="Digite uma observação..."
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                style={{ marginTop: 8 }}
            />
            <Divider />
            <div style={{ display: "flex", gap: 24 }}>
                <div style={{ flex: 1 }}>
                    <Text strong>Alterações</Text>

                    <div
                        style={{
                            maxHeight: 300,
                            overflowY: "auto",
                            paddingRight: 7,
                            scrollbarColor: "#d9d9d9 transparent",
                        }}
                    >
                        <Timeline style={{ marginTop: 12 }}>
                            {data.historico?.length ? (
                                data.historico.map((item: any, index: number) => (
                                    <Timeline.Item key={index}>
                                        <div>
                                            <Text strong>{item.status}</Text>
                                            <br />
                                            <Text type="secondary">
                                                {convertDataUSParaBrasilEHora(item.data)}
                                            </Text>
                                            {item.usuario_nome && (
                                                <>
                                                    <br />
                                                    <Text type="secondary">
                                                        Por: {item.usuario_nome}
                                                    </Text>
                                                </>
                                            )}
                                        </div>
                                    </Timeline.Item>
                                ))
                            ) : (
                                <Timeline.Item>
                                    <Text type="secondary">Sem histórico</Text>
                                </Timeline.Item>
                            )}
                        </Timeline>
                    </div>
                </div>

                <div style={{ flex: 1 }}>
                    <Text strong>Observações</Text>

                    <div
                        style={{
                            maxHeight: 300,
                            overflowY: "auto",
                            paddingRight: 7,
                            scrollbarColor: "#d9d9d9 transparent",
                        }}
                    >
                        <Timeline style={{ marginTop: 12 }}>
                            {data.observacoes?.length ? (
                                data.observacoes.map((item: any, index: number) => (
                                    <Timeline.Item key={index}>
                                        <div>
                                            <Text>
                                                {item.observacao}
                                            </Text>

                                            <br />

                                            <Text type="secondary">
                                                {convertDataUSParaBrasilEHora(item.data)}
                                            </Text>

                                            {item.usuario_nome && (
                                                <>
                                                    <br />
                                                    <Text type="secondary">
                                                        Por: {item.usuario_nome}
                                                    </Text>
                                                </>
                                            )}
                                        </div>
                                    </Timeline.Item>
                                ))
                            ) : (
                                <Timeline.Item>
                                    <Text type="secondary">Sem histórico</Text>
                                </Timeline.Item>
                            )}
                        </Timeline>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StatusModalBody;
